// Admin Panel Mock Data

export const adminCredentials = {
  username: 'admin',
  password: 'Admin@12'
};

export const adminStats = {
  totalUsers: 12543,
  activeAgents: 847,
  totalCalls: 1250000,
  revenue: 485000,
  growthRate: 23.5,
  avgCallDuration: '4:32'
};

export const recentUsers = [
  { id: 1, name: 'John Smith', email: 'john@company.com', role: 'Enterprise', status: 'active', agents: 12, joinDate: '2025-06-15' },
  { id: 2, name: 'Sarah Johnson', email: 'sarah@startup.io', role: 'Pro', status: 'active', agents: 5, joinDate: '2025-06-14' },
  { id: 3, name: 'Mike Chen', email: 'mike@tech.com', role: 'Enterprise', status: 'active', agents: 28, joinDate: '2025-06-12' },
  { id: 4, name: 'Emily Davis', email: 'emily@agency.co', role: 'Starter', status: 'pending', agents: 2, joinDate: '2025-06-10' },
  { id: 5, name: 'Robert Wilson', email: 'robert@corp.net', role: 'Pro', status: 'active', agents: 8, joinDate: '2025-06-08' },
  { id: 6, name: 'Lisa Anderson', email: 'lisa@business.com', role: 'Enterprise', status: 'suspended', agents: 15, joinDate: '2025-05-28' },
  { id: 7, name: 'David Brown', email: 'david@firm.org', role: 'Starter', status: 'active', agents: 3, joinDate: '2025-05-25' },
  { id: 8, name: 'Jennifer Taylor', email: 'jen@solutions.io', role: 'Pro', status: 'active', agents: 6, joinDate: '2025-05-20' },
];

export const voiceAgents = [
  { id: 1, name: 'Sales Assistant', owner: 'John Smith', language: 'English', calls: 15420, status: 'active', created: '2025-05-01' },
  { id: 2, name: 'Support Bot', owner: 'Sarah Johnson', language: 'Spanish', calls: 8930, status: 'active', created: '2025-05-10' },
  { id: 3, name: 'Appointment Scheduler', owner: 'Mike Chen', language: 'English', calls: 22150, status: 'active', created: '2025-04-15' },
  { id: 4, name: 'Lead Qualifier', owner: 'Emily Davis', language: 'French', calls: 3200, status: 'paused', created: '2025-06-01' },
  { id: 5, name: 'Collection Agent', owner: 'Robert Wilson', language: 'English', calls: 45000, status: 'active', created: '2025-03-20' },
  { id: 6, name: 'Survey Caller', owner: 'Lisa Anderson', language: 'German', calls: 12800, status: 'inactive', created: '2025-04-05' },
];

export const permissions = [
  { id: 1, name: 'User Management', description: 'Create, edit, delete users', category: 'Users', enabled: true },
  { id: 2, name: 'View Analytics', description: 'Access analytics dashboard', category: 'Analytics', enabled: true },
  { id: 3, name: 'Export Data', description: 'Export reports and data', category: 'Analytics', enabled: true },
  { id: 4, name: 'Agent Management', description: 'Manage voice AI agents', category: 'Agents', enabled: true },
  { id: 5, name: 'Billing Access', description: 'View and manage billing', category: 'Billing', enabled: true },
  { id: 6, name: 'API Keys', description: 'Generate and manage API keys', category: 'Developer', enabled: true },
  { id: 7, name: 'System Settings', description: 'Modify system configuration', category: 'System', enabled: true },
  { id: 8, name: 'Audit Logs', description: 'View system audit logs', category: 'System', enabled: true },
  { id: 9, name: 'Role Management', description: 'Create and edit roles', category: 'Users', enabled: true },
  { id: 10, name: 'Integration Settings', description: 'Configure integrations', category: 'Developer', enabled: true },
];

export const roles = [
  { id: 1, name: 'Super Admin', users: 2, permissions: 'All', color: 'red' },
  { id: 2, name: 'Admin', users: 5, permissions: '8/10', color: 'orange' },
  { id: 3, name: 'Manager', users: 12, permissions: '6/10', color: 'blue' },
  { id: 4, name: 'Support', users: 25, permissions: '4/10', color: 'green' },
  { id: 5, name: 'Viewer', users: 50, permissions: '2/10', color: 'gray' },
];

export const auditLogs = [
  { id: 1, action: 'User Created', user: 'Admin', target: 'john@company.com', timestamp: '2025-07-10 14:32:15', ip: '192.168.1.100' },
  { id: 2, action: 'Agent Deployed', user: 'John Smith', target: 'Sales Assistant', timestamp: '2025-07-10 13:45:22', ip: '10.0.0.55' },
  { id: 3, action: 'Permission Changed', user: 'Admin', target: 'Manager Role', timestamp: '2025-07-10 12:18:45', ip: '192.168.1.100' },
  { id: 4, action: 'Settings Updated', user: 'Admin', target: 'Email Config', timestamp: '2025-07-10 11:05:33', ip: '192.168.1.100' },
  { id: 5, action: 'User Suspended', user: 'Admin', target: 'lisa@business.com', timestamp: '2025-07-09 16:22:10', ip: '192.168.1.100' },
  { id: 6, action: 'API Key Generated', user: 'Mike Chen', target: 'Production Key', timestamp: '2025-07-09 15:10:45', ip: '172.16.0.25' },
  { id: 7, action: 'Bulk Export', user: 'Admin', target: 'User Data CSV', timestamp: '2025-07-09 14:05:18', ip: '192.168.1.100' },
  { id: 8, action: 'Login Success', user: 'Sarah Johnson', target: '-', timestamp: '2025-07-09 09:30:00', ip: '203.45.67.89' },
];

export const systemSettings = {
  general: {
    siteName: 'AIConneqtors',
    supportEmail: 'support@aiconneqtors.com',
    timezone: 'America/New_York',
    dateFormat: 'MM/DD/YYYY',
    maintenanceMode: false
  },
  security: {
    twoFactorAuth: true,
    sessionTimeout: 30,
    passwordExpiry: 90,
    maxLoginAttempts: 5,
    ipWhitelist: false
  },
  notifications: {
    emailAlerts: true,
    slackIntegration: true,
    webhookUrl: 'https://hooks.slack.com/services/xxx',
    dailyReport: true
  },
  api: {
    rateLimit: 1000,
    webhookRetries: 3,
    apiVersion: 'v2',
    sandboxMode: false
  }
};
